import { render, staticRenderFns } from "./wtButton.component.vue?vue&type=template&id=571ac740&scoped=true&"
import script from "./wtButton.component.vue?vue&type=script&lang=js&"
export * from "./wtButton.component.vue?vue&type=script&lang=js&"
import style0 from "./wtButton.component.vue?vue&type=style&index=0&id=571ac740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ac740",
  null
  
)

export default component.exports